
import { Vue, Component, Prop } from "vue-property-decorator";

import LIST_COMPANY_POSTINGS from "@/apollo/jobboard/ListCompanyPostings.gql";

import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import PostingCard from "@/components/recruitings/PostingCardNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import PostingModal from "@/components/postings/PostingModalNew.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";

import { Posting } from "@/interface";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import EmptyListImagePosting from "@/components/icons/emptyListImages/EmptyListImagePosting.vue";

@Component({
  components: {
    EmptyListImagePosting,
    LoadingOverlay,
    CardPagination,
    PostingCard,
    EmptyListPlaceholder,
    PostingModal,
    UiButtonMessage,
    PlusIcon,
  },
  apollo: {
    postings: {
      query: LIST_COMPANY_POSTINGS,
      variables() {
        return this.postingListConditions;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.posting.length;
        this.totalPostings = data.total.aggregate.count;
        return data.posting;
      },
    },
  },
})
export default class JobPostings extends Vue {
  @Prop({ type: String, required: true }) readonly managerFullName!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly managerId!: string;

  postings?: Posting[];
  postingModalShown: boolean = false;
  totalPostings: number = 0;

  paginationConfig: PaginationConfig = { ...paginationConfig };

  get postingListConditions(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    return {
      offset: nextOffset,
      limit: limit,
      where: {
        manager_id: {
          _eq: this.managerId,
        },
      },
      companyId: this.companyId,
    };
  }

  get emptyListTitle(): string {
    return `${this.managerFullName} does not have any postings yet`;
  }

  get isEmpty(): boolean {
    return !this.postings || this.postings.length === 0;
  }

  showNewPostingModal(): void {
    this.postingModalShown = true;
  }
}
